function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 46,
  height: 46,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_28274",
  "data-name": "Group 28274"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_61157",
  "data-name": "Path 61157",
  d: "M27.7,18.7A9.009,9.009,0,1,0,14,11a9.071,9.071,0,0,0,4.3,7.7A16.978,16.978,0,0,0,6,35v6H8V35a15,15,0,0,1,30,0v6h2V35A16.978,16.978,0,0,0,27.7,18.7ZM16,11a7,7,0,1,1,7,7A6.957,6.957,0,0,1,16,11Z",
  fill: "#d7272f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_61158",
  "data-name": "Path 61158",
  d: "M24,30H22v3H19v2h3v3h2V35h3V33H24Z",
  fill: "#d7272f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_61159",
  "data-name": "Path 61159",
  d: "M23,25a9,9,0,1,0,9,9A8.963,8.963,0,0,0,23,25Zm0,16a7,7,0,1,1,7-7A6.957,6.957,0,0,1,23,41Z",
  fill: "#d7272f"
}));

var SvgAddCustomer = function SvgAddCustomer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_new_customer",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddCustomer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-customer.e0c9b41e.svg";
export { ForwardRef as ReactComponent };